<div class="center-content">
  <div>
    <ng-content></ng-content>
  </div>
</div>
